/*!

=========================================================
* NextJS Material Kit PRO v1.3.1 based on Material Kit PRO - v2.0.2 (Bootstrap 4.0.0 Final Edition) and Material Kit PRO React v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/ct-nextjs-material-kit-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import App from "next/app";
import Head from "next/head";
import Router from "next/router";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import tribalismTheme from "/theme/tr-theme";
import createEmotionCache from "/utils/createEmotionCache";

import PageChange from "/components/PageChange/PageChange.js";

import "/styles/scss/nextjs-material-kit-pro.scss";

import "/styles/css/react-demo.css";

import "animate.css/animate.min.css";

// import { useEffect } from 'react';
import TagManager from "react-gtm-module";

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

Router.events.on("routeChangeStart", (url) => {
  console.log(`Loading: ${url}`);
  document.body.classList.add("body-page-transition");
  ReactDOM.render(
    <PageChange path={url} />,
    document.getElementById("page-transition")
  );
});
Router.events.on("routeChangeComplete", () => {
  ReactDOM.unmountComponentAtNode(document.getElementById("page-transition"));
  document.body.classList.remove("body-page-transition");
});
Router.events.on("routeChangeError", () => {
  ReactDOM.unmountComponentAtNode(document.getElementById("page-transition"));
  document.body.classList.remove("body-page-transition");
});

const tagManagerArgs = {
  gtmId: "GTM-KHJGW6",
};

export default class MyApp extends App {
  componentDidMount() {
    let comment = document.createComment(`

`);

    TagManager.initialize(tagManagerArgs);
    document.insertBefore(comment, document.documentElement);
  }

  static async getInitialProps({ Component, router, ctx }) {
    let pageProps = {};

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    return { pageProps };
  }
  render() {
    const { Component, pageProps, emotionCache = clientSideEmotionCache } = this.props;

    return (
      <CacheProvider value={emotionCache}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <link rel="shortcut icon" href="/img/A - 48 x 48.png" />
        </Head>

        <ThemeProvider theme={tribalismTheme}>
          <Component {...pageProps} />
        </ThemeProvider>
      </CacheProvider>
    );
  }
}
